export default {
    install(Vue) {
        Vue.config.globalProperties.$filters = {
            opnApiResult: function(val) {
                if(val == "SUCCESS") {
                    return true;
                }
                return false;
            },

            dateFormat_YYYYMMDDHHMMSS: function(val) {
                let myDate = new Date(val * 1000);
                let year = myDate.getFullYear();
                let month = ('0' + (myDate.getMonth() + 1)).slice(-2);
                let day = ('0' + myDate.getDate()).slice(-2);
                let hours = ('0' + myDate.getHours()).slice(-2);
                let minutes = ('0' + myDate.getMinutes()).slice(-2);
                let seconds = ('0' + myDate.getSeconds()).slice(-2);
                let dateString = year + '-' + month  + '-' + day + " " + hours + ':' + minutes  + ':' + seconds;
                
                return String(dateString);
            },
            
            dateFormat_YYYYMMDD: function(val) {
                let myDate = new Date(val * 1000);
                let year = myDate.getFullYear();
                let month = ('0' + (myDate.getMonth() + 1)).slice(-2);
                let day = ('0' + myDate.getDate()).slice(-2);
                let dateString = year + '-' + month  + '-' + day;
                
                return String(dateString);
            },
        
            bizNumber: function(value) {
                if(value){
                    value = value.replace(/[^0-9]/g, "");
                    
                    let tempNum = '';
                    
                    tempNum += value.substr(0,3);
                    tempNum += '-';
                    tempNum += value.substr(3,2);
                    tempNum += '-';
                    tempNum += value.substr(5);
                    
                    return String(tempNum);
                }else{
                    return value;
                }
            },
        
            phoneNumber: function(value) {
                if (!value) {
                    return "";
                }
                
                value = value.replace(/[^0-9]/g, "");
        
                let result = [];
                let restNumber = "";
                
                // 지역번호와 나머지 번호로 나누기
                if (value.startsWith("02")) {
                    // 서울 02 지역번호
                    result.push(value.substr(0, 2));
                    restNumber = value.substring(2);
                } else if (value.startsWith("1")) {
                    // 지역 번호가 없는 경우
                    // 1xxx-yyyy
                    restNumber = value;
                } else {
                    // 나머지 3자리 지역번호
                    // 0xx-yyyy-zzzz
                    result.push(value.substr(0, 3));
                    restNumber = value.substring(3);
                }
                
                if (restNumber.length === 7) {
                    // 7자리만 남았을 때는 xxx-yyyy
                    result.push(restNumber.substring(0, 3));
                    result.push(restNumber.substring(3));
                } else {
                    result.push(restNumber.substring(0, 4));
                    result.push(restNumber.substring(4));
                }
                
                return result.filter((val) => val).join("-");
            },
            
            comma: function(val) {
                return String(Math.round(val)).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
         };
    }
}